<template>  
    <div class="flex flex-column">
        <div class="flex flex-row align-items-center mb-3">
            <span class="text-2xl font-medium text-900">В.карта</span>
        </div>
    </div>  

    <div v-if="!loading && card" class="w-full flex flex-column gap-7">
        <div class="flex flex-column gap-3 align-items-left max-w-30rem">
            <div class="flex flex-row gap-2 align-items-center">
                <span class="flex flex-1">ID</span>
                <span class="flex overflow-hidden" style="max-width:7em">
                    <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                        {{ card._id }}
                    </span>
                </span>...
                <Button icon="pi pi-copy" @click="copy(card._id)" size="small" class="border-none" severity="secondary" outlined/>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">ID карты вендора</span>
                <span class="flex overflow-hidden" style="max-width:7em">
                    <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                        {{ card.vendor_card_id }}
                    </span>
                </span>...
                <Button icon="pi pi-copy" @click="copy(card.vendor_card_id)" size="small" class="border-none" severity="secondary" outlined/>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">Пользователь</span>
                <span class="flex overflow-hidden" style="max-width:7em">
                    <span class="white-space-nowrap text-primary cursor-pointer" @click="goToUser(card.user_id, false)" style="text-overflow:ellipsis;">
                        {{ card.user_id }}
                    </span>
                </span>...
                <Button icon="pi pi-copy" @click="copy(card.user_id)" size="small" class="border-none" severity="secondary" outlined/>
                <Button icon="pi pi-external-link" @click="goToUser(card.user_id, true)" size="small" class="border-none" severity="info" outlined/>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">Вендор</span>
                <span class="flex">{{getVendorName(card.vendor_id)}}</span>
                <Button icon="pi pi-copy" @click="copy(card.vendor_id)" size="small" class="border-none" severity="secondary" outlined/>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">Активность</span>
                <span class="flex">{{ (card.active) ? 'Активна' : 'Неактивна' }}</span>
                <Button icon="pi pi-pencil" @click="showEdit = true" size="small" class="border-none" severity="secondary" outlined/>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">Статус</span>
                <span class="flex">{{ card.status }}</span>
            </div>
            <div class="flex flex-row font-medium">
                <span class="flex flex-1">Баланс</span>
                <span class="flex">{{ getFormatAmount(card.balance, card.currency_code) }}</span>
            </div>
            <div class="flex flex-row">
                <span class="flex flex-1"></span>
                <Button label="Списать" @click="showWithdraw = true" size="small" class="bg-orange-500 border-orange-500 text-white" icon="pi pi-arrow-up" iconPos="right"/>
            </div>
            <div class="flex flex-row font-medium">
                <span class="flex flex-1">Потрачено</span>
                <span class="flex">{{ getFormatAmount(card.spent, card.currency_code) }}</span>
            </div>
            <div class="flex flex-row font-medium">
                <span class="flex flex-1">Лимит</span>
                <span class="flex">{{ getFormatAmount(card.cap, card.currency_code) }}</span>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">Валюта</span>
                <span class="flex">{{ card.currency_code }}</span>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">Бренд</span>
                <span class="flex">{{ card.brand }}</span>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">Создана</span>
                <span class="flex">{{ card.created }}</span>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">Email</span>
                <span class="flex">{{ card.email }}</span>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">Дата</span>
                <span class="flex">{{ card.expiration_date_short }}</span>
            </div>
            <div class="flex flex-row gap-1 align-items-center">
                <span class="flex flex-1">4 цифры</span>
                <span class="flex">...{{ card.last4 }}</span>
            </div>
        </div>
       
        <!--Transactions-->
        <div v-if="!loading && card && card.transactions && card.transactions.length>0" class="w-full">
            <div class="w-full mb-5">
                <div class="w-full flex flex-row mb-3">
                    <div class="flex flex-1 align-items-center">
                        <span class="text-xl font-medium text-900">Транзакции</span>
                    </div>
                    <div class="flex">
                        <Button v-if="!loading && card && card.transactions && card.transactions.length>0"
                            label="Все транзакции" @click="toTransactions()" size="small" severity="secondary"
                            class="flex surface-0 text-xs" icon="pi pi-arrow-right" iconPos="right" rounded />
                    </div>
                </div>
            </div>
            <div class="w-full flex">
                <Transactions 
                :transactions="card.transactions" 
                :loading="loading" 
                :total="100" 
                :skip="0"
                :limit="100" />
            </div>
        </div>
    </div>

    <div v-if="loading" class="w-full py-3">
        <Skeleton height="2rem" class="mb-3"/> 
    </div>

    <Withdraw v-if="card" v-model:visible="showWithdraw" :card="card" @success="onWithdrawSuccess" />
    <Edit v-if="card" v-model:visible="showEdit" :card="card" @success="onEditSuccess" />


</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Transactions from    '@/components/personal/Transactions.vue'
import Edit from '@/components/admin/vcard/Edit.vue'
import Withdraw from '@/components/admin/vcard/Withdraw.vue'
import { useRoute } from 'vue-router'

export default {
    data() {
        return {
            loading: false,
            card_id: null,
            card: null,
            showEdit: false,
            showWithdraw: false,
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    methods: {
        toTransactions(){
            this.$router.push(`/admin/vcard/${this.card_id}/transactions/`)
        },
        async GetCard(id){
            this.loading = true
            try {
                let card = await this.connect.GetVcardDetails(id).then(res => res)
                if (!card.result || !card.data) {
                    this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка загрузки данных', life: 10000 })
                    return
                } else {
                    this.card = card.data
                }
            } catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка загрузки данных', life: 10000 })
            }
            this.loading = false
        },
        async onWithdrawSuccess() {
            await this.GetCard(this.card_id)
        },
        async onEditSuccess() {
            await this.GetCard(this.card_id)
        },
        resetFilter() {
            this.filters.user_id.value = null
            this.filters.vendor_id.value = null
            this.lazyParams.filters = this.filters
            this.GetList()
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        goToUser(id, newTab = false) {
            if (newTab) window.open(`/admin/user_wallet/${id}/`, '_blank')
            else this.$router.push(`/admin/user/${id}/`)
        },
        getVendorName(vendorId) {
            return this.helper.getVendorName(vendorId)
        },
        getFormatAmount(value, currency, digits = 2) {
            if(!value) return 0
            return this.helper.format_amount(value, currency, digits)
        },
    },
    components: {
        Edit,
        Transactions,
        Withdraw,
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)) this.user_id = route.params.id
        this.card_id = route.params.id
        try{
            await this.GetCard(this.card_id).then(res=>res)
        }catch (error) {
            this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка загрузки данных', life: 10000 })
        }
    },
}
</script>